module.exports = __webpack_public_path__ + "img/freelancer.5cfb4121.png";